// -*- Mode: rjsx -*-
import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import Snackbar from '@mui/material/Snackbar';

import MoneyIcon from '@mui/icons-material/AttachMoney';
import StatusIcon from '@mui/icons-material/LinearScale';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import EmailIcon from '@mui/icons-material/Email';

import CopyIcon from '@mui/icons-material/Assignment';
import CopiedIcon from '@mui/icons-material/AssignmentTurnedIn';

import Icon from '@mui/material/Icon';

import Skeleton from 'react-loading-skeleton';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@mui/material/IconButton';

import { Success, Error, AdminDetail, FHTheme, FHMaterialStyles } from '../../../ui';

import { CARD_TITLE_PROPS } from '..';

function Price(props) {

    return (
        props.price ? <Typography>asdf {props.price}</Typography> : <Skeleton/>
    );   
}


function EmailDetail(props) {
    const request = props.request;
    const [recentlyCopied, setRecentlyCopied] = useState(false);
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(false);        
    
    const iconEmpty = <CopyIcon />;
    const iconFull = <CopiedIcon style={{ color: "green" }} />;

    let iconSecondary = recentlyCopied ? iconFull : iconEmpty;

    function copyToClipboard(e) {
        setRecentlyCopied(true);

        try {
            navigator.clipboard.writeText(request.contact.email).
                then((data) => {
                    setOpen(true);
                    setTimeout(() => setRecentlyCopied(false), 1200);
                }).catch((err) => {
                    console.error("Error in writeText: %o", error);
                });
        }
        catch(error) {
            console.error("caught the error: %o", error);            
            setError(true);
            setRecentlyCopied(false);
//            setOpen(false);
        }

    }

    function handleClose() {
        setOpen(false);
        setError(false);        
    }

    return (
        <div>
          <AdminDetail
            tooltip="Use this email address if you need to fill out a form, etc."
            label="Request Email"
            value={request.contact.email}
            valueElement={<div style={{ overflow: 'hidden', whiteSpace: 'nowrap' }}>{request.contact.email}</div>}
            icon={<EmailIcon />}
            secondaryAction={copyToClipboard}
            secondaryActionIcon={iconSecondary} />

          {/* <Success open={open} onClose={handleClose}>Email address copied to clipboard.</Success> */}
          <Error open={error} onClose={handleClose}>Could not copy to clipboard!</Error>          
          
        </div>
    );
          
}

function Details(props) {
	let request = props.request;
    const classes = FHMaterialStyles();
//    console.log("Details: req: %o", request);
    return (
        <Card>
          <CardHeader title="Request Details" titleTypographyProps={CARD_TITLE_PROPS} />
          <CardContent>
            <Grid container>
              
              <Grid item >
                
                <List dense={true}>

                  <AdminDetail
                    label="Price"
                    value={request.payment.price}
                    valueElement={<span style={{color: FHTheme.palette.money}}>{request.payment.price}</span>}
                    icon={<MoneyIcon />} />
                  
                  <AdminDetail
                    label="Status"
                    value={request.status_name}
                    icon={<StatusIcon />} />

                  <AdminDetail
                    label="Credits"
                    value={request.credits}
                    icon={<ConfirmationNumberIcon />} />

                  <EmailDetail request={request} />
                  
                </List>
              </Grid>
            </Grid>            
          </CardContent>
        </Card>
		
	);
}

export default  Details ;
